import { render, staticRenderFns } from "./VaccinationsForm.vue?vue&type=template&id=df70f4d8"
import script from "./VaccinationsForm.vue?vue&type=script&lang=js"
export * from "./VaccinationsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports